// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Input,
//   Button,
//   Modal,
//   Space,
//   message,
//   Row,
//   Col,
//   InputNumber,
// } from "antd";
// import {
//   PlusOutlined,
//   EditOutlined,
//   ReloadOutlined,
//   SearchOutlined,
// } from "@ant-design/icons";
// import axios from "axios";
// import {
//   create_Client,
//   get_ListeClients,
//   update_Client,
// } from "../../api/clients";
// import Notification from "../../composants/Notification";
// import { getPermissionsFromToken, hasPermission } from "../../utils/utils";
// const Clients = () => {
//   const [clients, setClients] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchText, setSearchText] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [editingClient, setEditingClient] = useState(null);
//   const [formData, setFormData] = useState({
//     ref: "",
//     nom: "",
//     nif: "",
//     stat: "",
//     rcs: "",
//     status_social: "",
//     description: "",
//     contact: "",
//     telephone: "",
//     addresse: "",
//     echeance_devis: 0,
//     echeance_facture: 0,
//   });
//   const [showToast, setshowToast] = useState(false);
//   const [notif, setnotif] = useState({
//     message: null,
//     info: null,
//   });
//   // 🔹 Charger les clients
//   const fetchClients = async () => {
//     setLoading(true);
//     try {
//       const res = await get_ListeClients();
//       setClients(res.data.data);
//       setFilteredData(res.data);
//     } catch (err) {
//       message.error("Erreur de chargement des clients");
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchClients();
//   }, []);

//   // 🔹 Filtrage
//   const handleSearch = (e) => {
//     const value = e.target.value.toLowerCase();
//     setSearchText(value);
//     const filtered = clients.filter((c) =>
//       Object.values(c).some((field) =>
//         field ? field.toString().toLowerCase().includes(value) : false
//       )
//     );
//     setFilteredData(filtered);
//   };

//   // 🔹 Ouvrir modal (ajout ou édition)
//   const openModal = (client = null) => {
//     setEditingClient(client);
//     if (client) {
//       console.log(client);
//       setFormData(client);
//     } else {
//       setFormData({
//         ref: "",
//         nom: "",
//         nif: "",
//         stat: "",
//         rcs: "",
//         status_social: "",
//         description: "",
//         contact: "",
//         telephone: "",
//         addresse: "",
//       });
//     }
//     setModalVisible(true);
//   };

//   // 🔹 Soumission (ajout ou édition)
//   const handleSubmit = async () => {
//     try {
//       setLoading(true);
//       if (editingClient) {
//         const res = await update_Client(editingClient.id, formData);
//         if (res.status === "success") {
//           setnotif({
//             ...notif,
//             message: "Clients modifié vec succés",
//             info: "success",
//           });
//           setshowToast(true);
//           setTimeout(() => {
//             window.location.reload();
//           }, 1500);
//           fetchClients();
//           setModalVisible(false);
//         } else {
//           setnotif({
//             ...notif,
//             message: "Erreur modification clients",
//             info: "error",
//           });
//           setshowToast(true);
//           setTimeout(() => {
//             setLoading(false);
//           }, 1500);
//         }
//       } else {
//         const res = await create_Client(formData);
//         if (res.status === "success") {
//           setnotif({
//             ...notif,
//             message: "Clients ajouté vec succés",
//             info: "success",
//           });
//           setshowToast(true);
//           setTimeout(() => {
//             window.location.reload();
//           }, 1500);
//           fetchClients();
//           setModalVisible(false);
//         } else {
//           setnotif({
//             ...notif,
//             message: "Erreur insertion clients",
//             info: "error",
//           });
//           setshowToast(true);
//           setTimeout(() => {
//             setLoading(false);
//           }, 1500);
//         }
//       }
//     } catch (err) {
//       message.error("Erreur lors de l’enregistrement");
//     }
//   };

//   // 🔹 Suppression
//   // 🔹 Colonnes du tableau
//   const columns = [
//     { title: "Ref", dataIndex: "ref", key: "ref" },
//     { title: "Nom", dataIndex: "nom", key: "nom" },
//     { title: "NIF", dataIndex: "nif", key: "nif" },
//     { title: "STAT", dataIndex: "stat", key: "stat" },
//     { title: "RCS", dataIndex: "rcs", key: "rcs" },
//     {
//       title: "Status social",
//       dataIndex: "status_social",
//       key: "status_social",
//     },
//     { title: "Description", dataIndex: "description", key: "description" },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (_, record) => (
//         <Space>
//           {
//             hasPermission(getPermissionsFromToken(), "CLIENT_UPDATE") && <Button
//               size="small"
//               icon={<EditOutlined />}
//               onClick={() => openModal(record)}
//               style={{
//                 backgroundColor: "#ffc107",
//                 borderColor: "#ffc107",
//                 color: "#000",
//               }}
//             />
//           }

//         </Space>
//       ),
//     },
//   ];

//   // 🔹 Gestion des changements d’inputs
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   return (
//     <div className="p-0">
//       <div className="flex justify-between items-center mb-4">
//         <Space>
//           <Input
//             placeholder="🔍 Rechercher..."
//             value={searchText}
//             onChange={handleSearch}
//             prefix={<SearchOutlined />}
//             style={{ width: 250 }}
//           />

//           <Button
//             icon={<ReloadOutlined />}
//             onClick={fetchClients}
//             loading={loading}
//             style={{
//               backgroundColor: "#0d6efd", // bootstrap primary
//               borderColor: "#0d6efd",
//               color: "#fff",
//             }}
//           >
//             Rafraîchir
//           </Button>

//           {
//             hasPermission(getPermissionsFromToken(), "CLIENT_ADD") && <Button
//               icon={<PlusOutlined />}
//               onClick={() => openModal()}
//               style={{
//                 backgroundColor: "#198754", // bootstrap success
//                 borderColor: "#198754",
//                 color: "#fff",
//               }}
//             >
//               Ajouter
//             </Button>
//           }

//         </Space>
//       </div>
//       <div style={{
//         height: '62vh',
//         overflowY: "auto"
//       }}>
//         <Table
//           dataSource={filteredData}
//           columns={columns}
//           rowKey="id"
//           bordered
//           loading={loading}
//           pagination={{
//             pageSize: 10,
//             position: ["bottomCenter"],
//             className: "custom-pagination",
//             style: {
//               display: "flex",
//               justifyContent: "center",
//               marginTop: 12,
//             },
//             itemRender: (page, type, originalElement) => {
//               if (type === "page") {
//                 return (
//                   <div
//                     style={{
//                       borderRadius: "50%",
//                       minWidth: 32,
//                       height: 32,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       border: "1px solid #d9d9d9",
//                     }}
//                   >
//                     {page}
//                   </div>
//                 );
//               }
//               return originalElement;
//             },
//           }}
//         />
//       </div>

//       {/* 🔹 Modal de création / édition */}
//       <Modal
//         title={editingClient ? "Modifier le client" : "Nouveau client"}
//         open={modalVisible}
//         onOk={handleSubmit}
//         onCancel={() => setModalVisible(false)}
//         okText="Enregistrer"
//         cancelText="Annuler"
//       >
//         <div>
//           {/* 🔹 Référence visible uniquement en mode édition */}
//           {editingClient && (
//             <Row style={{ marginBottom: 8 }}>
//               <Col span={6} style={{ padding: 4 }}>
//                 Référence :
//               </Col>
//               <Col span={18}>
//                 <Input
//                   placeholder="Référence"
//                   name="ref"
//                   value={formData.ref}
//                   disabled
//                 />
//               </Col>
//             </Row>
//           )}

//           <Row style={{ marginBottom: 8 }}>
//             <Col span={6} style={{ padding: 4 }}>
//               Nom :
//             </Col>
//             <Col span={18}>
//               <Input
//                 placeholder="Nom du client"
//                 name="nom"
//                 value={formData.nom}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           <Row style={{ marginBottom: 8 }}>
//             <Col span={6} style={{ padding: 4 }}>
//               Contact :
//             </Col>
//             <Col span={18}>
//               <Input
//                 placeholder="Contact avec le client"
//                 name="contact"
//                 value={formData.contact}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           <Row style={{ marginBottom: 8 }}>
//             <Col span={6} style={{ padding: 4 }}>
//               Télephone :
//             </Col>
//             <Col span={18}>
//               <Input
//                 placeholder="Numero de téléphone du contact"
//                 name="telephone"
//                 value={formData.telephone}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           <Row style={{ marginBottom: 8 }}>
//             <Col span={6} style={{ padding: 4 }}>
//               Addresse :
//             </Col>
//             <Col span={18}>
//               <Input
//                 placeholder="Lacalisation du client"
//                 name="addresse"
//                 value={formData.addresse}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           <Row style={{ marginBottom: 8 }}>
//             <Col span={6} style={{ padding: 4 }}>
//               NIF :
//             </Col>
//             <Col span={18}>
//               <Input
//                 placeholder=""
//                 name="nif"
//                 value={formData.nif}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           <Row style={{ marginBottom: 8 }}>
//             <Col span={6} style={{ padding: 4 }}>
//               STAT :
//             </Col>
//             <Col span={18}>
//               <Input
//                 placeholder=""
//                 name="stat"
//                 value={formData.stat}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           <Row style={{ marginBottom: 8 }}>
//             <Col span={6} style={{ padding: 4 }}>
//               RCS :
//             </Col>
//             <Col span={18}>
//               <Input
//                 placeholder=""
//                 name="rcs"
//                 value={formData.rcs}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           <Row style={{ marginBottom: 8 }}>
//             <Col span={6} style={{ padding: 4 }}>
//               Statut social :
//             </Col>
//             <Col span={18}>
//               <Input
//                 placeholder="SARL, SAS, etc."
//                 name="status_social"
//                 value={formData.status_social}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           <Row style={{ marginBottom: 8 }}>
//             <Col span={6} style={{ padding: 4 }}>
//               Echeance devis:
//             </Col>
//             <Col span={4}>
//               <InputNumber
//                 size="small"
//                 name="echeance_devis"
//                 value={formData.echeance_devis}
//                 onChange={(value) => {
//                   setFormData({
//                     ...formData,
//                     echeance_devis: value,
//                   });
//                 }}
//                 style={{ width: "100%" }}
//               />
//             </Col>
//             <Col span={2} style={{ padding: 8 }}>
//               j
//             </Col>
//             <Col span={6} style={{ padding: 4 }}>
//               Echeance facture:
//             </Col>
//             <Col span={4}>
//               <InputNumber
//                 size="small"
//                 name="echeance_facture"
//                 value={formData.echeance_facture}
//                 onChange={(value) => {
//                   setFormData({
//                     ...formData,
//                     echeance_facture: value,
//                   });
//                 }}
//                 style={{ width: "100%" }}
//               />
//             </Col>
//             <Col span={2} style={{ padding: 8 }}>
//               j
//             </Col>
//           </Row>

//           <Row>
//             <Col span={6} style={{ padding: 4 }}>
//               Description :
//             </Col>
//             <Col span={18}>
//               <Input.TextArea
//                 rows={3}
//                 placeholder="Description sur les activités de l'netreprise"
//                 name="description"
//                 value={formData.description}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>
//         </div>
//       </Modal>
//       {showToast && (
//         <Notification message={notif.message} status={notif.info} />
//       )}
//     </div>
//   );
// };

// export default Clients;

import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  Input,
  Button,
  Modal,
  Space,
  Row,
  Col,
  InputNumber,
  Form,
  Tag,
  Tooltip,
  Typography,
  Divider,
  message,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  ReloadOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  create_Client,
  get_ListeClients,
  update_Client,
} from "../../api/clients";
import Notification from "../../composants/Notification";
import { getPermissionsFromToken, hasPermission } from "../../utils/utils";

const { Title, Text } = Typography;

const EMPTY_CLIENT = {
  ref: "",
  nom: "",
  nif: "",
  stat: "",
  rcs: "",
  status_social: "",
  description: "",
  contact: "",
  telephone: "",
  addresse: "",
  echeance_devis: 0,
  echeance_facture: 0,
};

const Clients = () => {
  const [form] = Form.useForm();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [editingClient, setEditingClient] = useState(null);
  const [notif, setNotif] = useState({ message: null, info: null, key: 0 });

  const permissions = getPermissionsFromToken();
  const canAdd = hasPermission(permissions, "CLIENT_ADD");
  const canUpdate = hasPermission(permissions, "CLIENT_UPDATE");

  // 🔹 Notification (key => remonte le composant à chaque appel)
  const notify = (msg, info) =>
    setNotif((n) => ({ message: msg, info, key: n.key + 1 }));

  // 🔹 Charger les clients
  const fetchClients = async () => {
    setLoading(true);
    try {
      const res = await get_ListeClients();
      console.log(res);
      const list = res?.data?.data ?? res?.data ?? [];
      setClients(Array.isArray(list) ? list : []);
    } catch (err) {
      message.error("Erreur de chargement des clients");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchClients();
  }, []);

  // 🔹 Filtrage (dérivé : toujours cohérent avec clients + recherche)
  const filteredData = useMemo(() => {
    const value = searchText.trim().toLowerCase();
    if (!value) return clients;
    return clients.filter((c) =>
      Object.values(c).some((field) =>
        field !== null && field !== undefined
          ? field.toString().toLowerCase().includes(value)
          : false
      )
    );
  }, [clients, searchText]);

  // 🔹 Ouvrir modal (ajout ou édition)
  const openModal = (client = null) => {
    setEditingClient(client);
    form.resetFields();
    form.setFieldsValue(client ? { ...EMPTY_CLIENT, ...client } : EMPTY_CLIENT);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setEditingClient(null);
  };

  // 🔹 Soumission (ajout ou édition)
  const handleSubmit = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return; // erreurs de validation affichées dans le formulaire
    }

    setSaving(true);
    try {
      const res = editingClient
        ? await update_Client(editingClient.id, { ...editingClient, ...values })
        : await create_Client(values);

      if (res?.status === "success") {
        notify(
          editingClient
            ? "Client modifié avec succès"
            : "Client ajouté avec succès",
          "success"
        );
        closeModal();
        fetchClients();
      } else {
        notify(
          editingClient
            ? "Erreur modification client"
            : "Erreur insertion client",
          "error"
        );
      }
    } catch (err) {
      message.error("Erreur lors de l’enregistrement");
    }
    setSaving(false);
  };

  // 🔹 Colonnes du tableau
  const columns = [
    // {
    //   title: "Réf.",
    //   dataIndex: "ref",
    //   key: "ref",
    //   width: 110,
    //   sorter: (a, b) => (a.ref || "").localeCompare(b.ref || ""),
    //   render: (ref) => (ref ? <Tag color="blue">{ref}</Tag> : "—"),
    // },
    {
      title: "Client",
      dataIndex: "nom",
      key: "nom",
      sorter: (a, b) => (a.nom || "").localeCompare(b.nom || ""),
      defaultSortOrder: "ascend",
      render: (nom, r) => (
        <div style={{ lineHeight: 1.3 }}>
          <Text strong>{nom || "—"}</Text>
          {r.status_social && (
            <div>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {r.status_social}
              </Text>
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Contact",
      key: "contact",
      render: (_, r) => (
        <div style={{ lineHeight: 1.3 }}>
          <div>{r.contact || "—"}</div>
          {r.telephone && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              {r.telephone}
            </Text>
          )}
        </div>
      ),
    },
    { title: "NIF", dataIndex: "nif", key: "nif", width: 140 },
    { title: "STAT", dataIndex: "stat", key: "stat", width: 140 },
    { title: "RCS", dataIndex: "rcs", key: "rcs", width: 140 },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: { showTitle: false },
      render: (d) => (
        <Tooltip title={d} placement="topLeft">
          {d || "—"}
        </Tooltip>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 90,
      align: "center",
      fixed: "right",
      render: (_, record) =>
        canUpdate && (
          <Tooltip title="Modifier">
            <Button
              size="small"
              shape="circle"
              icon={<EditOutlined />}
              onClick={() => openModal(record)}
              style={{
                backgroundColor: "#ffc107",
                borderColor: "#ffc107",
                color: "#000",
              }}
            />
          </Tooltip>
        ),
    },
  ];

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 16,
      }}
    >
      {/* 🔹 En-tête + barre d'outils */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <div>
          <Title level={4} style={{ margin: 0 }}>
            Clients
          </Title>
          <Text type="secondary">
            {filteredData.length} résultat{filteredData.length > 1 ? "s" : ""}
            {searchText && ` sur ${clients.length}`}
          </Text>
        </div>

        <Space wrap>
          <Input
            allowClear
            placeholder="Rechercher un client..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
            style={{ width: 280 }}
          />
          <Tooltip title="Rafraîchir">
            <Button
              icon={<ReloadOutlined />}
              onClick={fetchClients}
              loading={loading}
            />
          </Tooltip>
          {canAdd && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => openModal()}
              style={{ backgroundColor: "#198754", borderColor: "#198754" }}
            >
              Ajouter un client
            </Button>
          )}
        </Space>
      </div>

      {/* 🔹 Tableau */}
      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="id"
        size="middle"
        loading={loading}
        scroll={{ x: 1000, y: "calc(80vh - 260px)" }}
        locale={{ emptyText: "Aucun client trouvé" }}
        // pagination={{
        //   pageSize: 10,
        //   showSizeChanger: true,
        //   pageSizeOptions: [10, 20, 50],
        //   position: ["bottomCenter"],
        //   showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total}`,
        // }}
        pagination={{
            pageSize: 8,
            position: ["bottomCenter"],
            className: "custom-pagination",
            style: {
              display: "flex",
              justifyContent: "center",
              marginTop: 12,
            },
            itemRender: (page, type, originalElement) => {
              if (type === "page") {
                return (
                  <div
                    style={{
                      borderRadius: "50%",
                      minWidth: 32,
                      height: 32,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #d9d9d9",
                    }}
                  >
                    {page}
                  </div>
                );
              }
              return originalElement;
            },
          }}
      />

      {/* 🔹 Modal de création / édition */}
      <Modal
        title={editingClient ? "Modifier le client" : "Nouveau client"}
        open={modalVisible}
        onOk={handleSubmit}
        onCancel={closeModal}
        okText="Enregistrer"
        cancelText="Annuler"
        confirmLoading={saving}
        width={720}
        forceRender
        maskClosable={false}
      >
        <Form form={form} layout="vertical" requiredMark="optional">
          <Divider orientation="left" plain style={{ marginTop: 0 }}>
            Informations générales
          </Divider>
          <Row gutter={16}>
            {editingClient && (
              <Col span={8}>
                <Form.Item label="Référence" name="ref">
                  <Input disabled />
                </Form.Item>
              </Col>
            )}
            <Col span={editingClient ? 16 : 24}>
              <Form.Item
                label="Nom"
                name="nom"
                rules={[{ required: true, message: "Le nom est obligatoire" }]}
              >
                <Input placeholder="Nom du client" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Contact" name="contact">
                <Input placeholder="Personne à contacter" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Téléphone" name="telephone">
                <Input placeholder="Numéro de téléphone du contact" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Adresse" name="addresse">
                <Input placeholder="Localisation du client" />
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left" plain>
            Informations légales
          </Divider>
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label="NIF" name="nif">
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="STAT" name="stat">
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="RCS" name="rcs">
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Statut social" name="status_social">
                <Input placeholder="SARL, SAS..." />
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left" plain>
            Conditions de paiement
          </Divider>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Échéance devis" name="echeance_devis">
                <InputNumber min={0} addonAfter="jours" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Échéance facture" name="echeance_facture">
                <InputNumber min={0} addonAfter="jours" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Description" name="description" style={{ marginBottom: 0 }}>
                <Input.TextArea
                  rows={3}
                  placeholder="Activités de l'entreprise"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      {notif.message && (
        <Notification
          key={notif.key}
          message={notif.message}
          status={notif.info}
        />
      )}
    </div>
  );
};

export default Clients;